var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#1f1f1f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "abb_rapid-tasks_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Robotics"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21,2H5V30H27V8Zm4,26H7V4H20l5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9,17.08a6.92,6.92,0,0,0,13.13,3.06l-1.79-.93a4.92,4.92,0,1,1-4.42-7.06A4.84,4.84,0,0,1,19.72,14H17.08v2H23V10H21v2.39A6.91,6.91,0,0,0,9,17.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateDocument);
export default __webpack_public_path__ + "static/media/UpdateDocument.b45ec1a867b575fdc7bf190afb9f44b9.svg";
export { ForwardRef as ReactComponent };